import { BillingCollectionStatus } from "../../../../../services/cloudchipr.api";

export const isBillingErrorStatus = (
  status: BillingCollectionStatus | undefined,
): boolean => {
  return status === "error" || status === "missing_data";
};
